/* global axios */
import ApiClient from './ApiClient';

class PurchaseIntegrationsAPI extends ApiClient {
  constructor() {
    super('integrations/purchase_integrations', { accountScoped: true });
  }

  getStatus() {
    return axios.get(this.url);
  }

  connect(provider, payload = {}) {
    return axios.post(`${this.url}/${provider}`, payload);
  }

  update(provider, payload = {}) {
    return axios.patch(`${this.url}/${provider}`, payload);
  }

  disconnect(provider) {
    return axios.delete(`${this.url}/${provider}`);
  }
}

export default new PurchaseIntegrationsAPI();
